/* eslint-disable @next/next/no-css-tags */
/* eslint-disable @next/next/no-img-element */
import { useRef, useEffect } from "react";

import { sanityClient, PortableText } from "../../lib/sanity";
import styles from "../../styles/Home.module.scss";
import WhiteBlueIllustration from "../../components/elements/WhiteBlueIllustration";
import PeopleSliderFlat from "../../components/elements/peeps/PeopleSliderFlat";
import NumberedCopyBlock from "../../components/elements/NumberedCopyBlock";
import IntroCopyBlock from "../../components/elements/IntroCopyBlock";
import NewsBlocks from "../../components/elements/NewsBlocks";
import Spacer from "../../components/elements/Spacer";
import TestimonialsSlider from "../../components/elements/TestimonialsSlider";
import Button from "../../components/elements/Button";
import StandardLayout from "../../components/layouts/StandardLayout";
import Stripe from "../../components/layouts/Stripe";
import DownloadFile from "../../components/elements/DownloadFile";
import GreenQuote from "../../components/GreenQuote";

import GalleryName from "../../components/elements/GalleryName";

const more2ChildCareQuery = `
{"more2ChildCareQueryInfoQuery": *[_id=="3d1a9763-40fd-4cd5-a107-78759db4fddb"] {
  title,
  meta,
  introheading,
  introcopy,
  pagequote,
  pinkmessage,
  paragraphs,
  customblocks,
  headerimage,
},
  "companyInfoQuery" : *[_type=="company"] {
    title,
    overlaytitle,
    message,
    footer,
    sociallinks,
    email,
    numbers
  },

  "peopleInfoQuery" : *[_type=='people' && location->_id=='ab0895b9-6505-49ea-b284-0455f2f34135'] |  order(_createdAt asc) {
    _id,
    image,
    name,
    slug
  },
  "latestNewsQuery" : *[_type=="latestnews" && (location->_id=='ab0895b9-6505-49ea-b284-0455f2f34135' || alllocations == true )][0..2] {
    _id,
    title,
    slug,
    isexternal,
    externallink,
    date,
    author,
    image,
    newsintro
  },
  "testimonialsQuery" : *[_type=="testimonials" && (location->_id=='ab0895b9-6505-49ea-b284-0455f2f34135' || applyToAllNurseries == true)] | order(orderRank asc) {
    _id,
    name,
    company,
    position,
    testimonial
  },
  "nurseryQuery" : *[_type=="nurseries"] {
    address,
    "manuscriptURL": manuscript.asset->url,
    linkaddress,
    mapimage
  }
}
`;

export default function RiversideNursery({
  more2ChildCareQueryInfoQuery,
  companyInfoQuery,
  peopleInfoQuery,
  latestNewsQuery,
  testimonialsQuery,
  nurseryQuery,
}) {
  const PageInfo = more2ChildCareQueryInfoQuery[0];
  const People = peopleInfoQuery;
  const Company = companyInfoQuery;
  const News = latestNewsQuery;
  const Testimonials = testimonialsQuery;
  const Nurseries = nurseryQuery;
  const PageQuote = PageInfo.pagequote;

  const containerRef = useRef(null);

  useEffect(() => {
    if (window && containerRef.current) {
      window.cloudinary
        .galleryWidget({
          container: containerRef.current,
          cloudName: "drdi7pcny",
          aspectRatio: "6:4",
          mediaAssets: [
            {
              tag: "riverside",
              transformation: {
                crop: "lfill",
                transformation: [{ gravity: "auto" }],
              },
            },
          ],
          carouselLocation: "bottom",
          imageBreakpoint: 200,
          borderColor: "#cb8799",
          borderWidth: 4,

          thumbnailProps: {
            width: 95,
            height: 64,
            radius: 4,
            borderColor: "#74a2be",
            borderWidth: 0,
            gutter: 10,
            spacing: 10,
            selectedBorderPosition: "bottom",
            selectedStyle: "all",
            selectedBorderWidth: 5,
            transformation: {
              crop: "fill",
              transformation: [{ gravity: "auto" }],
            },
          },
          zoomPopupProps: {
            backdropColor: "#335ba5",
            backdropOpacity: 0.8,
          },
          zoomProps: {
            type: "popup",
            level: 2,
            lensOpacity: 0.3,
          },
          navigationButtonProps: {
            shape: "radius",
            size: 60,
          },
          themeProps: {
            primary: "#cb8799",
            onPrimary: "white",
            active: "#e1899b",
          },
        })
        .render();
    }
  });

  return (
    <>
      <StandardLayout
        CompanyInfo={Company}
        Nurseries={Nurseries}
        PageInfo={PageInfo}
        headerWidth={1920}
        headerHeight={600}
        headerMinHeight={300}
        hideLeadImage={false}
        hideLink={true}
      >
        <div className={styles.mainContent}>
          <div className="container">
            <IntroCopyBlock PageInfo={PageInfo} />

            <Spacer mt={4} />
            <div
              ref={containerRef}
              style={{ width: "100%", margin: "0", padding: "0" }}
            />

            <GalleryName
              location={`More2Riverside Nursery`}
              background={`#cb8799`}
            />

            <Spacer mt={4} />

            <NumberedCopyBlock PageInfo={PageInfo} paragraphNumber={0} />

            <Spacer mt={4} />
            <TestimonialsSlider Testimonials={Testimonials} />

            <Spacer mt={4} />
            <NumberedCopyBlock PageInfo={PageInfo} paragraphNumber={1} />
            <Spacer mt={4} />
            <NewsBlocks LatestNews={News} />
            <Spacer mt={4} />
            <NumberedCopyBlock PageInfo={PageInfo} paragraphNumber={2} />
            <NumberedCopyBlock PageInfo={PageInfo} paragraphNumber={3} />
          </div>
          <Stripe stripeColor={"#82a0bb"}>
            <PeopleSliderFlat
              People={People}
              numberOfSlidesOnLarge={5}
              borderColor={"inherit"}
              headingColor={"#FFF"}
            />
          </Stripe>
          <div className="container">
            <NumberedCopyBlock PageInfo={PageInfo} paragraphNumber={4} />
            <Spacer mt={3} />

            <div className="thirdsgrid">
              <div className="firstthird">
                <DownloadFile
                  link={"/admissions/nursery-tour-booking"}
                  button={"Fill in this Form"}
                  icon="/images/static/download-icon.svg"
                  title="BOOK YOUR TOUR"
                  copy="Come and have a look around"
                />
              </div>
              <div className="secondthird">
                <DownloadFile
                  link={"/nurseries/faq"}
                  button={"View Page"}
                  icon="/images/static/download-icon.svg"
                  title="VIEW FAQ'S"
                  copy="View our fees sheet here"
                />
              </div>
              <div className="thirdthird">
                <DownloadFile
                  link={`${Nurseries[1].manuscriptURL}?dl=`}
                  button={"Download File"}
                  icon="/images/static/download-icon.svg"
                  title="FEES SHEET"
                  copy="View our fees sheet here"
                />
              </div>
            </div>
          </div>
        </div>

        {PageQuote && <GreenQuote quote={PageQuote} />}
        <WhiteBlueIllustration />
      </StandardLayout>
    </>
  );
}

export async function getStaticProps() {
  const {
    more2ChildCareQueryInfoQuery,
    companyInfoQuery,
    peopleInfoQuery,
    latestNewsQuery,
    testimonialsQuery,
    nurseryQuery,
  } = await sanityClient.fetch(more2ChildCareQuery);
  return {
    props: {
      more2ChildCareQueryInfoQuery,
      companyInfoQuery,
      peopleInfoQuery,
      latestNewsQuery,
      testimonialsQuery,
      nurseryQuery,
    },
  };
}
